/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="66.56"
        height="95.57"
        viewBox="0 0 66.56 95.57"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="#ffb81c"
          d="M47.8 38.22v6h-29v-6Z"
          className="icon-fill icon-accent"/>
        <path
          fill="#fff"
          d="M44.4 1.05a1.25 1.25 0 0 1 1.25 1.25 12.36 12.36 0 0 1-24.71.7v-.72a1.25 1.25 0 0 1 2.5 0 9.86 9.86 0 0 0 19.71.62v-.62a1.25 1.25 0 0 1 1.25-1.23Z"
          className="icon-fill icon-base"/><path
          fill="#fff"
          d="M23.03 95.57h-.12L1.12 93.28a1.25 1.25 0 0 1-1.11-1.37.78.78 0 0 1 0-.16v-.12l17.23-50.35L9.17 10.2a1.29 1.29 0 0 1 .39-1.26l.1-.07L21.93.25a1.12 1.12 0 0 1 .57-.22h21.43a1.1 1.1 0 0 1 .59.15l.13.08 12.27 8.62a1.25 1.25 0 0 1 .52 1.21v.12l-8.09 31.07 17.17 50.38a1.24 1.24 0 0 1-.77 1.58l-.23.04h-.12l-21.79 2.26H23.03Zm20.4-2.5 20.19-2.08L46.86 41.7a1.39 1.39 0 0 1-.06-.57v-.14l7.94-30.61-11.22-7.89H23.03l-11.22 7.89 7.94 30.61a1.1 1.1 0 0 1 0 .57v.14L2.97 90.99l20.16 2.09Z"
          className="icon-fill icon-base"/>
      </svg>

    );
  }
}

Icon.displayName = 'DressIcon';

export default Icon;
